import { createApp } from 'vue';
import SearchBucket from '../vue/SearchBucket.vue';

const searchBucket = createApp({});

// Register components
searchBucket.component('search-bucket', SearchBucket);

// Mount to the same app instance
searchBucket.mount('#propertySearchVue');